import * as api from '../salesCallApi';
import { businessEntityActionCreators } from '../../businessEntity';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  FetchSalesCallsByDate,
  ISalesCall,
  salesCallActionCreators,
  SalesCallActionKeys
  } from '..';

function* fetchSalesCallsByDateSaga(action: FetchSalesCallsByDate) {
  //const loaded: boolean = yield select(salesCallsByDateLoaded, action.payload);

  const response: ISalesCall[] = yield call(api.fetchSalesCallsByDate, action.payload);

  yield put(salesCallActionCreators.processSalesCalls(response));
  yield put(businessEntityActionCreators.addSalesCalls(response));
  yield put(salesCallActionCreators.fetchSalesCallsByDateFulfilled(action.payload.date, response));
}

export function* watchFetchSalesCallsByDate() {
  yield takeEvery(SalesCallActionKeys.FETCH_SALESCALLS_BY_DATE, fetchSalesCallsByDateSaga);
}
